export default __webpack_public_path__ + "static/earth-7b2ed59a6e8c4d95028308ceb8935b30.svg";